import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Form, InputGroup, Collapse, Modal, Button, Image, Stack } from "react-bootstrap";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { NumericFormat } from "react-number-format";
import Select from "react-select";
import { Formik } from "formik";
import * as yup from "yup";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import DataTableLayout from "layouts/DatatableLayout";
import { ModalAllder } from "layouts/ModalAllder";
import { nanoid } from "nanoid";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/DeleteOutline";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import { base64ToBlob, calPriceByMstCategoryPriceTax, getDiscountValue, getEmpFullNameTHByEmpData, isOrderOverDue, isReadyToPrint, mappingOptionNewItemPrCol, NumberFormat, setProductRowVatByMstCategoryPrice, WDA } from "utils/HelperFunction";
import { getPresentProduct } from "../../redux/handlers/logic/getPresentationProduct.handler";
import { getPresentInfo } from "../../redux/handlers/logic/getPresentationInfo.handler";
import { clearCreatePresent, createPresent } from "../../redux/handlers/logic/createPresent.handler";
import { clearUpdatePresent, updatePresent } from "../../redux/handlers/logic/updatePresent.handler";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
var businessID = null;
export function Present() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState("สร้างนำเสนอ"), 2), headerName = _useState[0], setheaderName = _useState[1];
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var accessToken = localStorage.getItem("accessToken");
    var param = useParams();
    var pageId = React.useMemo(function() {
        return param.dataID ? param.dataID : null;
    }, [
        param.dataID
    ]);
    var _useState1 = _sliced_to_array(useState(0), 2), status = _useState1[0], setStatus = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), productRow = _useState2[0], setProductRow = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), row = _useState3[0], setRow = _useState3[1];
    if (accessToken) {
        try {
            var base64Url = accessToken.split(".")[1];
            if (base64Url) {
                try {
                    var _payload_member;
                    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
                    var payload = JSON.parse(atob(base64));
                    businessID = parseInt((_payload_member = payload.member) === null || _payload_member === void 0 ? void 0 : _payload_member.bus_business_id) || null;
                } catch (error) {
                    console.error("Failed to decode access token payload:", error);
                }
            } else {
                console.error("Invalid access token format.");
            }
        } catch (error) {
            console.error("Invalid access token:", error);
        }
    }
    var _useState4 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccessD = _useState4[0], setModalsuccessD = _useState4[1];
    var getPresentProductReducer = useAppSelector(function(state) {
        return state.getPresentProductReducer;
    });
    var getPresentInfoReducer = useAppSelector(function(state) {
        return state.getPresentInfoReducer;
    });
    var updatePresentReducer = useAppSelector(function(state) {
        return state.updatePresentReducer;
    });
    var createPresentReducer = useAppSelector(function(state) {
        return state.createPresentReducer;
    });
    useEffect(function() {
        dispatch(getPresentProduct(businessID, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        if (pageId != null && pageId != 0 && pageId != undefined) {
            setheaderName("แก้ไขนำเสนอ");
            dispatch(getPresentInfo(parseInt(pageId), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, []);
    var schema = yup.object().shape({
        name: yup.string().required()
    });
    var columns = [
        {
            name: "รหัสสินค้า",
            selector: function(row) {
                return row.code;
            },
            // center: "true",
            width: "170px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/product/productnormal/edit/" + row.product_id + "/view",
                        children: row.code ? row.code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "บาร์โค๊ด",
            selector: function(row) {
                return row.barcode;
            },
            // center: "true",
            width: "250px"
        },
        {
            name: "ชื่อสินค้า",
            // center: "true",
            width: "250px",
            selector: function(row) {
                return row.name;
            }
        },
        {
            name: "หน่วย",
            // center: "true",
            width: "120px",
            selector: function(row) {
                return row.unit;
            }
        },
        {
            name: "ราคานำเสนอ",
            center: "true",
            width: "120px",
            selector: function(row) {
                return row.pricePresent;
            }
        },
        {
            name: "ราคาขาย",
            center: "true",
            width: "120px",
            selector: function(row) {
                return row.priceRecommended;
            }
        },
        {
            name: "GP",
            center: "true",
            width: "120px",
            selector: function(row) {
                return row.gp;
            },
            cell: function(row, index, column, id) {
                return row.gp + " %";
            }
        },
        {
            name: "สถานะ",
            center: "true",
            width: "150px",
            selector: function(row) {
                return row.status;
            },
            cell: function(row, index, column, id) {
                return row.status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#6D788D)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "แบบร่าง"
                }) || row.status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FDB428",
                        backgroundColor: "#FFF6E5",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รออนุมัติ"
                }) || row.status == 3 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FFFFFF",
                        backgroundColor: "#10B02A",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "อนุมัติ"
                }) || row.status == 4 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่อนุมัติ"
                }) || row.status == 5 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#6f42c1",
                        backgroundColor: "#e2d9f3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รอแก้ไข"
                });
            }
        },
        {
            name: "จัดการ",
            center: "true",
            width: "120px",
            selector: function(row) {
                return row.id;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(DeleteIcon, {
                        style: {
                            color: "#FFFFFF",
                            fontSize: 30,
                            borderRadius: 40,
                            background: "#F95057",
                            padding: 5
                        },
                        onClick: function() {
                            return onDel(row.id);
                        }
                    })
                });
            }
        }
    ];
    var onDel = function(id) {
        var newRows = productRow.filter(function(item) {
            return item.id !== id;
        });
        setProductRow(newRows);
        var dData = formdata;
        dData.number = newRows.length;
        setFormdata.apply(void 0, _to_consumable_array(dData));
    };
    var defaultData = {
        code: "-",
        dateCreate: moment().format("DD/MM/YYYY"),
        name: "",
        number: 0,
        remark: ""
    };
    var _useState5 = _sliced_to_array(useState(defaultData), 2), formdata = _useState5[0], setFormdata = _useState5[1];
    var _useState6 = _sliced_to_array(useState(false), 2), formdisabled = _useState6[0], setFormdisabled = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), filterText = _useState7[0], setFilterText = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), filteredItems = _useState8[0], setFilteredItems = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1400,
        height: 650,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modal = _useState9[0], setModal = _useState9[1];
    var _useState10 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "success"
    }), 2), modalSuccess = _useState10[0], setModalSuccess = _useState10[1];
    useEffect(function() {
        setIsLoading(getPresentProductReducer.isFetching);
        if (getPresentProductReducer.data) {
            var newRow = getPresentProductReducer.data.data.map(function(item) {
                return {
                    id: item.pd_product_id,
                    code: item.pd_product_code,
                    barcode: item.pd_product_barcode,
                    name: item.pd_product_nameth,
                    option: "option",
                    unit: item.SetUnit ? item.SetUnit.set_unit_name : "-",
                    rate: item.pd_product_unitweightid,
                    pricePresent: item.pd_product_price,
                    priceRecommended: item.pd_product_recommentprice,
                    gp: item.pd_product_gp,
                    status: item.pd_product_status,
                    product_id: item.pd_product_id
                };
            });
            setRow(newRow);
            setFilteredItems(newRow);
        }
    }, [
        getPresentProductReducer
    ]);
    // GET DATA PRESENTATION
    useEffect(function() {
        setIsLoading(getPresentInfoReducer.isFetching);
        if (getPresentInfoReducer.data) {
            var newRow = getPresentInfoReducer.data.data.PdPpresendetail.map(function(item) {
                return {
                    id: item.pd_ppresendetail_id,
                    code: item.PdProduct.pd_product_code,
                    barcode: item.PdProduct.pd_product_barcode,
                    name: item.PdProduct.pd_product_nameth,
                    option: item.pd_ppresentation_option,
                    unit: item.PdProduct.SetUnit ? item.PdProduct.SetUnit.set_unit_name : "-",
                    rate: item.pd_ppresentation_rate,
                    pricePresent: item.PdProduct.pd_product_price,
                    priceRecommended: item.PdProduct.pd_product_recommentprice,
                    gp: item.PdProduct.pd_product_gp,
                    status: item.PdProduct.pd_product_status,
                    product_id: item.PdProduct.pd_product_id
                };
            });
            setProductRow(newRow);
            setFormdata({
                code: getPresentInfoReducer.data.data.pd_ppresentation_code,
                name: getPresentInfoReducer.data.data.pd_ppresentation_name,
                // number: newRow.length,
                dateCreate: getPresentInfoReducer.data.data.pd_ppresentation_credate ? new moment(getPresentInfoReducer.data.data.pd_ppresentation_credate).format("DD/MM/YYYY") : "",
                remark: getPresentInfoReducer.data.data.pd_ppresentation_remark
            });
        }
    }, [
        getPresentInfoReducer
    ]);
    useEffect(function() {
        setIsLoading(updatePresentReducer.isFetching);
        if (updatePresentReducer.data && !updatePresentReducer.isError) {
            // setModalNotApprove((prev) => ({ ...prev, open: false }));
            // setModalForceSuccess((prev) => ({ ...prev, open: false }));
            // getData();
            // setModalSuccess((prev) => ({ ...prev, open: true }));
            if (status == 2) {
                setModalsuccessD(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        textsuccess: "บันทึกสำเร็จ",
                        direction: "/product"
                    });
                });
            } else {
                setModalsuccessD(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        textsuccess: "บันทึกสำเร็จ",
                        direction: ""
                    });
                });
            }
            dispatch(clearUpdatePresent());
        }
    }, [
        updatePresentReducer
    ]);
    useEffect(function() {
        setIsLoading(createPresentReducer.isFetching);
        if (createPresentReducer.data && !createPresentReducer.isError) {
            if (status == 2) {
                setModalsuccessD(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        textsuccess: "บันทึกสำเร็จ",
                        direction: "/product"
                    });
                });
            } else {
                setModalsuccessD(function(prev) {
                    var _createPresentReducer_data_data, _createPresentReducer_data;
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        textsuccess: "บันทึกสำเร็จ",
                        direction: "/product/present/edit/" + (createPresentReducer === null || createPresentReducer === void 0 ? void 0 : (_createPresentReducer_data = createPresentReducer.data) === null || _createPresentReducer_data === void 0 ? void 0 : (_createPresentReducer_data_data = _createPresentReducer_data.data) === null || _createPresentReducer_data_data === void 0 ? void 0 : _createPresentReducer_data_data.pd_ppresentation_id)
                    });
                });
            }
            dispatch(clearCreatePresent());
        }
    }, [
        createPresentReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-1",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "สินค้าของฉัน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "นำเสนอสินค้า"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: headerName
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4",
                        children: headerName
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                validationSchema: schema,
                initialValues: formdata,
                validateOnMount: true,
                onSubmit: function(values) {
                    var newformData = {
                        pd_ppresentation_businessid: businessID,
                        pd_ppresentation_name: formdata.name,
                        pd_ppresentation_totalproduct: parseInt(productRow === null || productRow === void 0 ? void 0 : productRow.length),
                        pd_ppresentation_remark: formdata.remark,
                        pd_ppresentation_status: status
                    };
                    var detailcreate = [];
                    productRow.forEach(function(e, i) {
                        // const createPdPpresentation = {
                        //   pd_ppresendetail_id: e.id,
                        //   pd_ppresendetail_presentationid:  parseInt(pageId),
                        //   pd_ppresendetail_productid: e.product_id,
                        //   pd_ppresendetail_status: e.status,
                        // }\
                        var createPdPpresentation = {
                            pd_ppresendetail_productid: e.product_id
                        };
                        detailcreate.push(createPdPpresentation);
                    });
                    var data = _object_spread_props(_object_spread({}, newformData), {
                        detailcreate: detailcreate
                    });
                    if (pageId) {
                        dispatch(updatePresent(pageId, data, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    } else {
                        dispatch(createPresent(data, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    }
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, isInvalid = param.isInvalid, isValid = param.isValid;
                    return /*#__PURE__*/ _jsx("div", {
                        style: {
                            paddingBottom: "100px"
                        },
                        children: /*#__PURE__*/ _jsxs(Form, {
                            noValidate: true,
                            onSubmit: function(e) {
                                e.preventDefault();
                                handleSubmit();
                            },
                            children: [
                                /*#__PURE__*/ _jsxs("fieldset", {
                                    disabled: formdisabled,
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "card card-st-3 mb-3",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "card-body px-xl-3",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "tc-8  fs-18 fw-bold px-3",
                                                        children: "ข้อมูลสินค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "pt-3 px-3",
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            className: "row gx-xl-4",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-2 col-md-6",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "รหัสลิสต์"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "code",
                                                                                className: "form-control",
                                                                                placeholder: "รหัสลิสต์",
                                                                                value: values.code,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormdata(_object_spread_props(_object_spread({}, formdata), {
                                                                                        code: e.target.value
                                                                                    }));
                                                                                },
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-3 col-md-6",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: [
                                                                                    "ชื่อลิสต์",
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        className: "text-danger ms-1",
                                                                                        children: "*"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "name",
                                                                                className: "form-control",
                                                                                placeholder: "ชื่อลิสต์",
                                                                                value: values.name,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormdata(_object_spread_props(_object_spread({}, formdata), {
                                                                                        name: e.target.value
                                                                                    }));
                                                                                },
                                                                                isInvalid: !!errors.name
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-2 col-md-6",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "จำนวนรายการ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "number",
                                                                                className: "form-control",
                                                                                placeholder: "จำนวนรายการ",
                                                                                value: productRow === null || productRow === void 0 ? void 0 : productRow.length,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormdata(_object_spread_props(_object_spread({}, formdata), {
                                                                                        number: e.target.value
                                                                                    }));
                                                                                },
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-2 col-md-6",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "วันที่สร้าง"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "dateCreate",
                                                                                className: "form-control",
                                                                                placeholder: moment().format("DD/MM/YYYY"),
                                                                                value: values.dateCreate,
                                                                                onChange: handleChange,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-3 col-md-6",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "หมายเหตุ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "remark",
                                                                                className: "form-control",
                                                                                placeholder: "หมายเหตุ",
                                                                                value: values.remark,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormdata(_object_spread_props(_object_spread({}, formdata), {
                                                                                        remark: e.target.value
                                                                                    }));
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "fs-24 mb-4",
                                            children: "รายการสินค้าส่งนำเสนอ"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "card card-st-3",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "card-body px-xl-3",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4 mb-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-8 col-md-6"
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4 col-md-6 d-flex justify-content-end",
                                                                children: /*#__PURE__*/ _jsx(Stack, {
                                                                    direction: "horizontal",
                                                                    children: /*#__PURE__*/ _jsx(Button, {
                                                                        className: "btn btn-dg ml-2 py-2",
                                                                        style: {
                                                                            width: 150
                                                                        },
                                                                        onClick: function() {
                                                                            return setModal(function(prev) {
                                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                                    open: true
                                                                                });
                                                                            });
                                                                        },
                                                                        children: "เลือกสินค้า"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(DataTableLayout, {
                                                        item: productRow,
                                                        columns: columns,
                                                        isSelectRows: false,
                                                        PerPage: 10
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "card pagezoom card-st-3  mb-4 fixed bottom-0 w-[calc(100%-110px)] drop-shadow",
                                    style: {
                                        minWidth: "1000px"
                                    },
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body px-xl-3 d-flex",
                                        style: {
                                            justifyContent: "flex-end",
                                            alignItems: "flex-end"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(Button, {
                                                type: "button",
                                                className: "btn-st-6 me-3 btn",
                                                onClick: function(e) {
                                                    navigate("/product");
                                                },
                                                children: "ยกเลิก"
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                type: "button",
                                                onClick: function() {
                                                    setStatus(1);
                                                    handleSubmit();
                                                },
                                                className: "btn-st-9 me-3 btn",
                                                children: "บันทึกแบบร่าง"
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                type: "button",
                                                onClick: function() {
                                                    setStatus(2);
                                                    handleSubmit();
                                                },
                                                className: "btn btn-dg py-2",
                                                children: "ส่งอนุมัติ"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    });
                }
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modal,
                setModal: setModal,
                htitle: "เพิ่มสินค้าหลายรายการ",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductSelect, {
                    row: row,
                    setRow: setRow,
                    productRow: productRow,
                    setProductRow: setProductRow,
                    pageId: pageId,
                    formdata: formdata,
                    filteredItems: filteredItems,
                    setFilteredItems: setFilteredItems
                })
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccessD.visible,
                onHide: function() {
                    return setModalsuccessD(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccessD.textsuccess,
                navigate: navigate,
                direction: modalsuccessD.direction
            })
        ]
    });
}
function ProductSelect(_param) {
    var modal = _param.modal, setModal = _param.setModal, hbtn = _param.hbtn, htitle = _param.htitle, row = _param.row, setRow = _param.setRow, productRow = _param.productRow, setProductRow = _param.setProductRow, pageId = _param.pageId, formdata = _param.formdata, setFormdata = _param.setFormdata, filteredItems = _param.filteredItems, setFilteredItems = _param.setFilteredItems, props = _object_without_properties(_param, [
        "modal",
        "setModal",
        "hbtn",
        "htitle",
        "row",
        "setRow",
        "productRow",
        "setProductRow",
        "pageId",
        "formdata",
        "setFormdata",
        "filteredItems",
        "setFilteredItems"
    ]);
    var _useState = _sliced_to_array(useState([]), 2), optionsMasterCategory = _useState[0], setOptionsMasterCategory = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), optionsMasterBrand = _useState1[0], setOptionsMasterBrand = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), filterText = _useState2[0], setFilterText = _useState2[1];
    var _useState3 = _sliced_to_array(useState({
        category_id: "",
        brand_id: ""
    }), 2), optionFiltered = _useState3[0], setOptionFiltered = _useState3[1];
    var columns = [
        {
            field: "code",
            headerName: "รหัสสินค้า",
            headerAlign: "center",
            align: "center",
            minWidth: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("div", {
                        style: {
                            color: "#565DFF"
                        },
                        children: row.code
                    })
                });
            }
        },
        {
            field: "barcode",
            headerName: "บาร์โค้ด",
            minWidth: 250,
            flex: 1,
            sortable: true
        },
        {
            field: "name",
            headerName: "ชื่อสินค้า",
            minWidth: 250,
            flex: 1,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsxs("div", {
                        children: [
                            row.name,
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx("span", {
                                className: "fs-12",
                                style: {
                                    color: "#F26F3A"
                                },
                                children: row.barcode
                            }),
                            " "
                        ]
                    })
                });
            }
        },
        {
            field: "unit",
            headerName: "หน่วย",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
            sortable: true,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsxs(Stack, {
                    direction: "column",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: row.unit
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: row.rate
                        })
                    ]
                });
            }
        },
        {
            field: "pricePresent",
            headerName: "ราคานำเสนอ",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
            sortable: true
        },
        {
            field: "priceRecommended",
            headerName: "ราคาขาย",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
            sortable: true
        },
        {
            field: "gp",
            headerName: "GP",
            minWidth: 250,
            headerAlign: "center",
            align: "center",
            flex: 1,
            sortable: true
        },
        {
            field: "status",
            headerName: "สถานะ",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: true,
            renderCell: function(param) {
                var row = param.row;
                if (row.status === 1) {
                    return /*#__PURE__*/ _jsx("div", {
                        className: "px-2 py-1 text-center",
                        style: {
                            color: "#6D788D",
                            backgroundColor: "rgba(244, 244, 244, 1)",
                            borderRadius: "20px",
                            width: "150px"
                        },
                        children: "แบบร่าง"
                    });
                } else if (row.status === 2) {
                    return /*#__PURE__*/ _jsx("div", {
                        className: "px-2 py-1 text-center",
                        style: {
                            color: "#FDB428",
                            backgroundColor: "#FFF6E5",
                            borderRadius: "20px",
                            width: "150px"
                        },
                        children: "รออนุมัติ"
                    });
                } else if (row.status === 3) {
                    return /*#__PURE__*/ _jsx("div", {
                        className: "px-2 py-1 text-center",
                        style: {
                            color: "#FFFFFF",
                            backgroundColor: "#10B02A",
                            borderRadius: "20px",
                            width: "150px"
                        },
                        children: "อนุมัติ"
                    });
                } else if (row.status === 4) {
                    return /*#__PURE__*/ _jsx("div", {
                        className: "px-2 py-1 text-center",
                        style: {
                            color: "#F95057",
                            backgroundColor: "#FFE3E3",
                            borderRadius: "20px",
                            width: "150px"
                        },
                        children: "ไม่อนุมัติ"
                    });
                } else if (row.status === 5) {
                    return /*#__PURE__*/ _jsx("div", {
                        className: "px-2 py-1 text-center",
                        style: {
                            color: "#6f42c1",
                            backgroundColor: "#e2d9f3",
                            borderRadius: "20px",
                            width: "150px"
                        },
                        children: "รอแก้ไข"
                    });
                } else {
                    return null;
                }
            }
        }
    ];
    useEffect(function() {
        if (filterText) {
            setFilteredItems(row.filter(function(item) {
                return item.code && item.code.toLowerCase().includes(filterText.toLowerCase()) || item.barcode && item.barcode.toLowerCase().includes(filterText.toLowerCase()) || item.name && item.name.toLowerCase().includes(filterText.toLowerCase()) || item.unit && item.unit.toLowerCase().includes(filterText.toLowerCase());
            }));
        } else {
            setFilteredItems(row);
        }
    }, [
        row,
        filterText
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "d-flex align-items-center  mb-3 flex-wrap",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "me-3 mb-2",
                        children: /*#__PURE__*/ _jsx("input", {
                            type: "text",
                            className: "form-control form-st-4",
                            placeholder: "ค้นหา",
                            onChange: function(e) {
                                return setFilterText(e.target.value);
                            },
                            value: filterText
                        })
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        onClick: function() {
                            setFilterText("");
                        // setOptionFiltered({
                        //   category_id: "",
                        //   brand_id: "",
                        // });
                        },
                        type: "button",
                        className: "btn btn btn-st-v1 mb-2 px-4",
                        children: "ล้างค่าการค้นหา"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DataGrid, {
                getRowId: function(row) {
                    return row.product_id;
                },
                getRowHeight: function() {
                    return "auto";
                },
                rows: filteredItems,
                autoHeight: true,
                columns: columns,
                initialState: {
                    pagination: {
                        paginationModel: {
                            pageSize: 10
                        }
                    }
                },
                pageSizeOptions: [
                    10,
                    20,
                    30
                ],
                checkboxSelection: true,
                rowSelectionModel: productRow.map(function(item) {
                    return item.product_id;
                }),
                disableRowSelectionOnClick: true,
                slotProps: {
                    pagination: {
                        labelRowsPerPage: "จำนวนรายการต่อหน้า"
                    }
                },
                // disableMultipleRowSelection={true}
                sx: {
                    fontFamily: "Sarabun",
                    fontSize: "16px",
                    ".MuiDataGrid-columnHeaderTitle": {
                        fontFamily: "Sarabun",
                        fontSize: "16px"
                    },
                    "& .MuiDataGrid-virtualScrollerRenderZone": {
                        transform: "unset !important"
                    }
                },
                onRowSelectionModelChange: function(ids) {
                    var _arr;
                    var data = [];
                    var arr = [];
                    (_arr = arr).push.apply(_arr, _to_consumable_array(ids));
                    filteredItems.map(function(ele) {
                        var find = arr.find(function(val) {
                            return val == ele.id;
                        });
                        if (find) {
                            data.push(_object_spread({}, ele));
                        }
                    });
                    setProductRow(data);
                }
            })
        ]
    });
}
